import { Component, OnInit } from '@angular/core';

import { ScoringComponent } from '../scoring/scoring.component';
import { ExerciseStarterComponent } from '../exercise-starter/exercise-starter.component';


const DENOM1 = [ 2, 4, 5, 8, 10];
const DENOM2 = [ 2, 4, 5, 10, 20, 25, 50, 100];


@Component({
  selector: 'app-fractions-numbers',
  templateUrl: './fractions-numbers.component.html',
  styleUrls: ['./fractions-numbers.component.css']
})
export class FractionsNumbersComponent extends ScoringComponent {
  mLevel: number = 0;
  mState = '';
  mPoints = 0;
  mCalcState = 'false';
  inProblem: string = '\\frac{taeller}{naevner}';

  mDenoms = DENOM1;

  inputValue:number = null;
  
  numb1: number = 1;
  numb2: number = 1;
  result: number;
  resState = 'calculating'
  calcLevel: number;
  
  
  constructor() { super(); }
  
  ngOnInit() {
    this.numbOfCalcs = 2;
    this.mState = 'init';
  }  

  clearValue(){ 
    this.inputValue = null;
  }

  start() {
    this.mState = 'init';
    this.calcLevel = this.mLevel;
    this.initLevel(this.calcLevel);
    this.reset();
    this.newCalc();
  }

  newCalc(){
    this.resState = 'calculating';
    this.numb2 = this.newDenominator(this.numb2);
    this.numb1 = this.newNumerator(this.numb1, this.numb2);
    this.result = this.numb1 / this.numb2;
    this.inProblem  = '\\frac{'+this.numb1+'}{'+this.numb2+'}';    
    this.startTime(); 
    this.clearValue();
    document.getElementById('myRes').focus();
    //document.getElementById('myRes').innerText = '';
    //this.clearValue();
  }

  newDenominator(old: number): number {
    var newVal = old; 
    if (this.mLevel == 2)
    {
      while (old == newVal)
      {
        newVal = Math.floor(Math.random() * 18)+2;
      }  
    }
    else
    {
      while (old == newVal)
      {
        var index = Math.floor(Math.random() * this.mDenoms.length);
        newVal = this.mDenoms[index];
      }  
    }
    return newVal;
  }

  newNumerator(old: number, denom: number): number {
    var newVal = old;
    if (denom == 2)
    { 
      newVal = 1;
    } 
    else
    {
      while (old == newVal)
      {
        newVal = Math.floor(Math.random() * (denom-1))+1;
      }  
    }
    return newVal;
  }

  initLevel(val: number){
    if (val == 0)
    {
      this.setTimeBonus(0.001);
      this.mDenoms = DENOM1;
    }
    else if (val == 1)
    {
      this.setTimeBonus(0.003);
      this.mDenoms = DENOM2;
    }
    else
    {
      this.setTimeBonus(0.01);
    }
  }

  checkResult(value: number){

    var bres = false;
    if (this.mLevel == 2)
    {
      var margin = 0.001;
      if (value > this.result - margin ||
          value < this.result + margin)
      {
        bres = true;
      }
    }
    else if (value == this.result)
    {
      bres = true;
    }

    if (bres){
      this.resState = 'correct';  
      this.correct();
      
      setTimeout(()=>{this.nextStep();},1000);  
    } 
    else {
      this.resState = 'incorrect';    
      this.wrong();
    }
  }

  nextStep(){
    if(this.done())
    {
      this.mState = 'tryAgain';
      this.mPoints = this.givePoints();    
      this.mCalcState = 'false';
    }
    else
    {
      this.newCalc();
    }
  }

  update(value: number) {
    if (value && this.resState == 'calculating')
      this.checkResult(value);
  }

  setState(val: string) {
    this.mCalcState = 'true';
    this.start();
  }
        
  setLevel(newLevel: number)
  {
    if (newLevel && this.mLevel != newLevel)
    {
      this.mLevel = newLevel;
    }
  }
}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/fractions-numbers/fractions-numbers.component.ts